// utils/apartmentUtils.js
import { APARTMENT_MAP } from "@/IPA/Apartments";

/**
 * Returns a human label for apartment:
 * - number => map to enum name (e.g., 1 -> "Apartament 1")
 * - numeric string "1" => number -> same mapping
 * - other strings => returned as-is
 * - null/"" => "Fără apartament"
 */
export function getApartamentLabel(v) {
  if (v == null || v === "") return "Fără apartament";

  // normalize numeric strings like "1" -> 1
  if (typeof v === "string" && /^\d+$/.test(v.trim())) v = Number(v);

  if (typeof v === "number") return APARTMENT_MAP[v] ?? String(v);
  return String(v);
}

/**
 * Group key keeps the label, not the raw value,
 * so group headers show the human-readable apartment name.
 */
export function makeGroupKey(apartament, floor) {
  const label = getApartamentLabel(apartament);
  const f = Number(floor ?? 0);
  return `${label}|${f}`;
}
export function getUnitId(apartament) {
  if (apartament == null || apartament === "") return null;

  // dacă e numeric (inclusiv string "2")
  if (!isNaN(Number(apartament))) {
    return `unit_${Number(apartament)}`;
  }

  // fallback pentru text manual
  return `unit_${String(apartament).trim().replace(/\s+/g, "_")}`;
}